import React, { Component } from "react";
import { withRouter } from "./withRouter";
import mapboxgl from "mapbox-gl";
import { tableFromIPC } from "apache-arrow";
import { Box } from "@mui/material";
import MapComponent from "./MapComponent"
import { alpha } from '@mui/material/styles';
import ConstituencyGrid from "./ConstituencyGrid"
import NationalVoteBar from "./NationalVoteBar"
import CoalitionPerformanceBox from "./CoalitionPerformanceBox"
export function baseColorForLikertKey(group, key) {
  const pol = group.polarity || {};
  // Find which polarity (pos/neg/neu) corresponds to this key
  const tag = Object.entries(pol).find(([polarity, polKey]) => polKey === key)?.[0];

  
  if (tag === "pos") return "#2E7D32";
  if (tag === "neg") return "#C62828";
  return "#6e6e6e";
}
const rowsFromTable = (table) => {
  const cols = table.schema.fields.map(f => f.name);
  const rows = [];
  for (let i = 0; i < table.numRows; i++) {
    const obj = {};
    for (const c of cols) obj[c] = table.getChild(c).get(i);
    rows.push(obj);
  }
  return rows;
};

// Define party full names and official colours
const PARTY_INFO = {
    nat_pred_n: { name: "National", color: "#0056A8" },
    act_pred_n: { name: "ACT", color: "#FFD700" },
    nzf_pred_n: { name: "NZF", color: "#000000" },
    lab_pred_n: { name: "Labour", color: "#E82C2C" },
    green_pred_n: { name: "Green", color: "#009639" },
    tpm_pred_n: { name: "TPM", color: "#CC0033" },
    oth_pred_n: { name: "Other", color: "#999999" }
};

// Build labels and colors in one go
const buildLabelsAndColors = () => {
  const labels = {};
  const colors = {};

  Object.entries(PARTY_INFO).forEach(([key, info]) => {
    labels[key] = info.name;
    colors[key] = info.color;
  });

  return { labels, colors };
};




class NZ2026Home extends Component {
      constructor(props) {
    super(props);
    this.state = {
      geoLevel: "constituency",
      metricRows: null, 
      loading: false,
      hoverInfo: null,
      hoverAreaId: null,
      selectedStateBounds: null,
      selectedFeature: null,   
      geoData:props.constituencyMap,
      styleLoaded: false,
      viewState: null,
      metricRowsConst: null,
      metricRowsNational:null
    };
    
    this.mapRef = React.createRef();
    this._inflight = null; 
    this._lastKey = null;
    this._lastAt = 0;

    
  }

  
  componentDidMount() {
  const run = async () => {
    await this.fetchMetrics("national", null, true);
    await this.fetchMetrics("constituency", null, true);
  };
  run();
}

   componentDidUpdate(prevProps, prevState) {
    const groupChanged      = prevProps.selectedGroupId !== this.props.selectedGroupId;
   
    const levelChanged      = prevState.geoLevel !== this.state.geoLevel;

  
    const needRefetch = levelChanged  || groupChanged ;
    if (needRefetch) {
      this.fetchMetrics(this.state.geoLevel, this.state.selectedFeature?.area_id);
    }

  
    const rowsChanged  = prevState.metricRows !== this.state.metricRows;
    const geoChanged   = prevState.geoData !== this.state.geoData;
  
    if (geoChanged || rowsChanged || groupChanged) {
      this.restyle();
    }
  
   
    
  }
  _inflightBaseline = null;
  _lastBaselineKey = null;
  _lastBaselineAt = 0;
    requestKey = (level) => {

    return `${level}`;
  };


  //main function that grabs data
    fetchMetrics = async (level, constCode, save_const_results) => {
  const controller = new AbortController(); // new controller for this call
  const signal = controller.signal;

  const reqKey = this.requestKey(level);
  const now = Date.now();
  if (this._lastKey === reqKey && now - this._lastAt < 700) return;
  this._lastKey = reqKey;
  this._lastAt = now;


    let keysBody 
    if(level==="national"||save_const_results){
          keysBody= [
                    "nat_pred_n",
                    "lab_pred_n",
                    "act_pred_n",
                    "nzf_pred_n",
                    "green_pred_n",
                    "tpm_pred_n",
                    "oth_pred_n",
                    "inflation_issue_n",
                    "health_issue_n",
                    "econ_issue_n",
                    "crime_issue_n",
                    "housing_issue_n",
                    "poverty_issue_n",
                    "unemployment_issue_n",
                    "climate_issue_n",
                    "education_issue_issue_n",
                    "transport_issue_n",
                    "drugs_issue_n",
                    "race_rel_issue_n",
                    "tax_issue_n",
                    "pollution_issue_n",
                    "maori_issue_n",
                    "immigration_issue_n",
                    "defence_issue_n",
                    "gov_good_n",
                    "gov_bad_n",
                    "gov_dn_n",
                    "coalition_consider", 
                    "coalition_left_consider", 
                    "nat_consider", 
                    "act_consider", 
                    "nzf_consider", 
                    "lab_consider", 
                    "green_consider", 
                    "tpm_consider", 
                    "turnout_1_p"
                  ]  
    }else{
    keysBody= [
                    "nat_pred_n",
                    "lab_pred_n",
                    "act_pred_n",
                    "nzf_pred_n",
                    "green_pred_n",
                    "tpm_pred_n",
                    "oth_pred_n", 
                    "turnout_1_p"
                  ]
                }
                
    let turnout_weight
    turnout_weight = "turnout_1_n"
    const body = {
      groupKeys: keysBody,
      filters:[],
      constCode: constCode,
    turnout_weight: turnout_weight

    };
  
    this.setState({ loading: true });
  

 
    try {
      // --- call main metrics endpoint ---
          const resMain = await fetch(`/api/${level}_data_arrow/`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(body),
                signal,
                });
      if (!resMain.ok) throw new Error(`metrics fetch ${resMain.status}`);
      const bufMain = await resMain.arrayBuffer();
      const tableMain = tableFromIPC(bufMain);
      const rowsMain = rowsFromTable(tableMain);
      // --- update state with both ---
      if(save_const_results){
        if(level==="national"){
          this.setState(
             { metricRowsNational: rowsMain })
            }else{
            this.setState(
            { metricRowsConst: rowsMain ,
                metricRows: rowsMain,})
            }
      }else{
           this.setState({
        metricRows: rowsMain,
        loading: false,
        
      });
      }
   
    } catch (e) {
      if (e.name !== "AbortError") console.error("metrics error:", e);
      this.setState({ metricRows: null,  loading: false });
    } finally {
      this._inflight = null;
    }

  }

   restyle = () => {
    const { geoData, metricRows} = this.state;

  
    if (!geoData) {
      this.setState({ styledGeo: null });
      return;
    }
      if (!metricRows) {
      return;
    }
    const byId = new Map();
    for (const r of metricRows) {
      const id = String(r.area_id ?? "");
      if (id) byId.set(id, r);
    }


 
    const { labels, colors } = buildLabelsAndColors();

    const styled = {
      type: "FeatureCollection",
      features: geoData.features.map(f => {
        const rid = String(f.properties?.area_id ?? "");
        const row = byId.get(rid);
        
  
        if (!row) {
          return {
            ...f,
            properties: {
              ...f.properties,
              fillColor: "#ffffff",
              topLabel: "No data",
              topValue: 0,
              _allValues: {},
              _allValuesSorted: [],
            }
          };
        }
        const groupKeys = [
            "nat_pred_n",
            "lab_pred_n",
            "act_pred_n",
            "nzf_pred_n",
            "green_pred_n",
            "tpm_pred_n",
            "oth_pred_n"
            ]
  
        const displayKeys = (groupKeys || []).filter(k => k in row);
        if (displayKeys.length === 0) {
          return {
            ...f,
            properties: {
              ...f.properties,
              fillColor: "#ffffff",
              topLabel: "No data",
              topValue: 0,
              _allValues: {},
              _allValuesSorted: [],
            }
          };
        }
  
        const entries = displayKeys
          .map(k => ({
            key: k,
            area_name: labels[k] || k,
            area_id: Number(row[k]),
          }))
          .filter(e => Number.isFinite(e.area_id))
          .sort((a, b) => b.area_id - a.area_id);

  
        let fillColor = "#666";
        let topKey    = entries[0]?.key;
        let topLabel  = entries[0]?.area_name || "";
        let topValue  = entries[0]?.area_id || 0;
        fillColor = colors[topKey] || "#000000";

        let sortedvals

           sortedvals = entries
                  .map(e => ({
                    ...e,
                    order: e.key === "Net" ? Number.MAX_SAFE_INTEGER : 0 // net at bottom, others stay in original order
                  }))
                  .sort((a, b) => a.order - b.order)
                  .map(e => ({ key: e.key, area_name: e.area_name, area_id: e.area_id })); // remove order after sorting
     
        return {
          ...f,
          properties: {
            ...f.properties,
            fillColor,
            topKey,
            topLabel,
            topValue,
            _allValues: Object.fromEntries(entries.map(e => [e.key,e.area_name, e.area_id])),
            _allValuesSorted: sortedvals,
            Turnout: row?.turnout_1_p
          }
        };
      })
    };
  
    this.setState({ styledGeo: styled,styleLoaded: true });
  };

  fitBoundsFromFeatures = (features) => {
  if (!this.mapRef.current || !features?.length) return null;
  const map = this.mapRef.current.getMap();
  const bounds = new mapboxgl.LngLatBounds();
  this.setState({viewState:null})
  features.forEach(f => {
    const coords = f.geometry.type === "Polygon"
      ? f.geometry.coordinates.flat(1)
      : f.geometry.coordinates.flat(2);
    coords.forEach(([lng, lat]) => bounds.extend([lng, lat]));
  });
  map.fitBounds(bounds, { padding: 80, duration: 500 });
  return bounds;
};

  

   onMapClick = (evt) => {
    const feature = evt.features?.[0];
    if (!feature) return;
    const level = this.state.geoLevel;
    const p = feature.properties || {};
    const areaId = String(p.area_id ?? "");
    const map = this.mapRef.current?.getMap();


    const zoomToFeature = (feat) => this.fitBoundsFromFeatures([feat]);

    

    const clickedLevel = level;

    if (
      areaId &&
      this.state.selectedFeature &&
      this.state.selectedFeature.level === clickedLevel &&
      this.state.selectedFeature.area_id === areaId
    ) {
      this.setState({ selectedFeature: null }, () => {
        if (this.state.selectedStateBounds) {
          map?.fitBounds(this.state.selectedStateBounds, { padding: 80, duration: 500 });
        } else {
         // map?.fitBounds([[-125, 24], [-66, 49]], { padding: 20, duration: 500 });
        }

        this.props.onFeatureSelect?.({
          feature: null,
          selectedAreaLabel: null,
          selectedFeatureLevel: null,
        });
      });
      return;
    }

     if (level === "constituency") {
      const constCode = String(p.area_id || "")
      if (!constCode) return;
  
      const stateBounds = zoomToFeature(feature); // sets map to state
      const stateLabel =  p.area_name;
  
      this.setState(
        {
          selectedconstCode: constCode,
          selectedStateBounds: stateBounds,
          geoLevel: "SA3",
          // Keep selectedFeature pointing to the state context
          selectedFeature: {
            level: "constituency",
            key: "STATEFP",
            area_id: constCode,
            area_name: stateLabel,
            rowMatchIds: [constCode],
          },
        },
        () => {
          // Make sure county metrics (and secondary metrics) are loaded for tooltips
          this.fetchMetrics("SA3",constCode );
          // Load county geo for that state (no auto-fit; we already zoomed)
          this.loadGeo("SA3", { doFit: false });
                
  
        }
      );
      return;
    }


  };

    onMouseMove = (evt) => {
        const feature = evt.features && evt.features[0];
        if (!feature) return this.setState({ hoverInfo: null,hoverAreaId:null });
    
        const { lng, lat } = evt.lngLat; 
        this.setState({
        hoverInfo: { lon: lng, lat, props: feature.properties },
        hoverAreaId: feature.properties.area_id ?? null
        });
    };

  loadGeo = async (level) => {
    let newGeo 
    switch(level){
        case "constituency":
         newGeo = this.props.constituencyMap
        break
        case "SA3":
         newGeo = this.props.SA3Map
        break
        case "SA2":
         newGeo = this.props.SA2Map
        break

        
        default:
         newGeo = this.props.constituencyMap
        break
    }
    this.setState({geoData: newGeo, geoLevel: level
    })
  }

 onGeoLevelChange = (newLevel) => {
  if (!newLevel) return;

  // if these are async functions already, await them
  this.fetchMetrics(newLevel, this.state.selectedFeature?.area_id);
  this.loadGeo(newLevel);

  // return when both finish
};
    // Utility: compute bounds [minX, minY, maxX, maxY] from a FeatureCollection
getFeatureCollectionBounds = (featureCollection) => {
  let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;

  featureCollection.features.forEach((feat) => {
    const coords = feat.geometry.coordinates;

    const recurse = (arr) => {
      if (typeof arr[0] === "number") {
        const [x, y] = arr;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
      } else {
        arr.forEach(recurse);
      }
    };

    recurse(coords);
  });

  return [[minX, minY], [maxX, maxY]];
};
    

   resetView = ({ LevelToResetTo = "constituency" }) => {
    const map = this.mapRef.current?.getMap();
      if (map) {
    map.fitBounds(
      [
        [166.0, -47.5], // SW
        [179.0, -33.0], // NE
      ],
      { padding: 80 }
    );
  }

  this.setState(
    {
      geoLevel: LevelToResetTo,
      selectedStateCode: null,
      selectedStateBounds: null,
      selectedFeature: null,
      metricRows: null,
      styledGeo: null,
      
    },
    () => {
      this.onGeoLevelChange(LevelToResetTo);

    }
  );
};

handleselectedFeatureChange =  (area_id, area_name) => {



    const feature = this.props.constituencyMap.features.filter(
          f => String(f.properties.area_id) === String(area_id.area_id)
        )[0];
    if (!feature) return;
    const level = this.state.geoLevel;
    const p = feature.properties || {};
    const areaId = String(p.area_id ?? "");
    const map = this.mapRef.current?.getMap();

    const zoomToFeature = (feat) => this.fitBoundsFromFeatures([feat]);   

    const clickedLevel = level;


    if (
      areaId &&
      this.state.selectedFeature &&
      this.state.selectedFeature.level === clickedLevel &&
      this.state.selectedFeature.area_id === areaId
    ) {
      this.setState({ selectedFeature: null }, () => {
        if (this.state.selectedStateBounds) {
          map?.fitBounds(this.state.selectedStateBounds, { padding: 80, duration: 500 });
        } else {
         // map?.fitBounds([[-125, 24], [-66, 49]], { padding: 20, duration: 500 });
        }

        this.props.onFeatureSelect?.({
          feature: null,
          selectedAreaLabel: null,
          selectedFeatureLevel: null,
        });
      });
      return;
    }
      const stateBounds = zoomToFeature(feature); // sets map to state

      const constCode = String(p.area_id || "")
      if (!constCode) return;
  
      const stateLabel =  p.area_name;
  
      this.setState(
        {
          selectedconstCode: constCode,
          selectedStateBounds: stateBounds,
          geoLevel: "SA3",
          viewState:null,
          // Keep selectedFeature pointing to the state context
          selectedFeature: {
            level: "constituency",
            key: "area_id",
            area_id: constCode,
            area_name: stateLabel,
            rowMatchIds: [constCode],
            
          },
        },
        () => {
          // Make sure county metrics (and secondary metrics) are loaded for tooltips
          this.fetchMetrics("SA3",constCode );
          // Load county geo for that state (no auto-fit; we already zoomed)
          this.loadGeo("SA3", { doFit: false });
                
  
        }
      );
      return;
    

    
}


  render() {
  
  return(
<Box
  sx={{
    display: "flex",
    height: "92vh",      // own the height here
    width: "100%",
    overflow: "hidden",  // no page scrollbar
  }}
>
  {/* LEFT COLUMN */}
  <Box
    component="main"
    sx={(theme) => ({
      flex: 1,
      minWidth: 0,             // important for flex children
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      backgroundColor: theme.vars
        ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
        : alpha(theme.palette.background.default, 1),
    })}
  >
        <Box sx={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
        <MapComponent
            mapRef={this.mapRef}
            styledGeo={this.state.styledGeo}
            geoData={this.state.geoData}
            hoverInfo={this.state.hoverInfo}
            styleLoaded={this.state.styleLoaded}
            selectedFeature={this.state.selectedFeature}
            onMapClick={this.onMapClick}
            onMouseMove={this.onMouseMove}
            onGeoLevelChange={this.onGeoLevelChange}
            buildLabelsAndColors={buildLabelsAndColors}
            geoLevel={this.state.geoLevel}
            resetView={this.resetView}
            handleselectedFeatureChange={this.handleselectedFeatureChange}
            viewState={this.state.viewState}
            tooltip={"home"}
        />
        </Box>
    </Box>

    {/* RIGHT COLUMN */}
   <Box
        component="main"
        sx={(theme) => ({
            flex: 1,
            minWidth: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start",
               overflowY: "auto", 
            height: "100%",
            backgroundColor: theme.vars
            ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
            : alpha(theme.palette.background.default, 1),
        })}
        >
          
        {/* Main content flexes to fill */}
        <Box
            sx={{
            flex: 1,                 // take available height from parent
            display: "flex",
            flexDirection: "column",
            }}
        >
            {/* Top */}

              <Box
            sx={{
                flex: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                px: 2,
                pt: { xs: 2, md: 2, lg:2, xl:2 },
                pb: { xs: 2, md: 2, lg:2, xl:2 },
            }}
            >
              
            <NationalVoteBar
                metricRowsConst={this.state.metricRowsConst}
                metricRowsNat={this.state.metricRowsNational}
                selectedFeature={this.state.selectedFeature}
                WIDTH="90%"
            />
            </Box>
            <Box
            sx={{
                flex: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                px: 2,
                pt: { xs: 2, md: 2, lg:2, xl:2 },
                pb: { xs: 2, md: 2, lg:2, xl:2 },
            }}
            >
            <ConstituencyGrid metricRowsNational={this.state.metricRowsNational} />
            </Box>

            {/* Middle */}


            {/* Bottom pinned */}
            <Box sx={{ mt: "auto" }}>
            <CoalitionPerformanceBox
                metricRowsConst={this.state.metricRowsConst}
                metricRowsNat={this.state.metricRowsNational}
                selectedFeature={this.state.selectedFeature}
            />
            </Box>
        </Box>
        </Box>

 </Box>


  )
}


  }

export default withRouter(NZ2026Home);